module.exports = __webpack_public_path__ + "img/homey-icon.46165469.png";